import { axiosInstance } from "lib/axios";
import { PublisherSearchService } from "../services";

export function usePublisherSearch() {
  const pubService = new PublisherSearchService(axiosInstance);

  async function getPublisherToken(url) {
    try {
      const newUrl = await pubService.getPublisherToken(url);
      return newUrl.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  return {
    getPublisherToken
  };
}
